export default "__VITE_ASSET__1I8JhzlM__"